import React, {Component} from 'react';
import styles from './styles.css';

export default class Menu extends Component {
	render() {
		let className = styles['bsui-menu'];

		if (this.props.align) {
			className += ' ' + styles['bsui-menu_align_' + this.props.align];
		}

		if (this.props.type) {
			className += ' ' + styles['bsui-menu_type_' + this.props.type];
		}

		return <ul className={className}>{React.Children.toArray(this.props.children).map(
			(item, key) => <li key={key} className={styles['bsui-menu__item']}>{item}</li>)}</ul>;
	}
}